import React, { useState } from 'react';
import NavButton from '../../components/ul/NavButton';


const Navbar = ({ selectState }) => {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    const toggleMobileMenu = () => {
        setMobileMenuOpen(!mobileMenuOpen);
    };

    return (
        <nav className="text-main-font w-full p-4 mt-3">
            <div className="flex justify-between items-center">
                {/* Mobile menu button - only visible on small screens */}
                <button
                    className="lg:hidden focus:outline-none"
                    onClick={toggleMobileMenu}
                    aria-label={mobileMenuOpen ? "Close menu" : "Open menu"}
                >
                    {mobileMenuOpen ? (
                        <div className="h-6 w-6 flex items-center justify-center">
                            {/* X icon */}
                            <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                <line x1="18" y1="6" x2="6" y2="18"></line>
                                <line x1="6" y1="6" x2="18" y2="18"></line>
                            </svg>
                        </div>
                    ) : (
                        <div className="h-6 w-6 flex items-center justify-center">
                            {/* Menu icon */}
                            <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                <line x1="3" y1="12" x2="21" y2="12"></line>
                                <line x1="3" y1="6" x2="21" y2="6"></line>
                                <line x1="3" y1="18" x2="21" y2="18"></line>
                            </svg>
                        </div>
                    )}
                </button>

                {/* Desktop navigation - hidden on small screens */}
                <ul className="hidden lg:flex space-x-4">
                    <li>
                        <NavButton to="/manage/withdraw/coupon" btnName="Coupon" selectState={selectState === "coupon"} />
                    </li>
                    <li>
                        <NavButton to="/manage/withdraw/request" btnName="Request" selectState={selectState === "request"} />
                    </li>
                </ul>

            </div>

            {/* Mobile navigation - only shown when menu is open */}
            {mobileMenuOpen && (
                <div className="lg:hidden mt-4 bg-white shadow rounded-lg p-4">
                    <ul className="flex flex-col space-y-2">
                        <li>
                            <NavButton to="/manage/withdraw/coupon" btnName="Coupon" selectState={selectState === "coupon"} />
                        </li>
                    </ul>
                </div>
            )}
        </nav>
    );
};

export default Navbar;